import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-module-create-account-view',
  templateUrl: './module-create-account-view.component.html',
  styleUrls: ['./module-create-account-view.component.scss']
})
export class ModuleCreateAccountViewComponent implements OnInit {

  @Input() views: any;
  @Output() selectView = new EventEmitter();
  @Output() gotoPage = new EventEmitter();

  constructor() { }

  selectAccountView(view): void {
    this.selectView.emit(view);
  }

  navigate(page: number): void {
    this.gotoPage.emit(page);
  }

  ngOnInit() {
  }

}
